import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=fa5ef554&scoped=true"
import script from "./Quotes.vue?vue&type=script&lang=js"
export * from "./Quotes.vue?vue&type=script&lang=js"
import style0 from "./Quotes.vue?vue&type=style&index=0&id=fa5ef554&prod&lang=scss&scoped=true"
import style1 from "./Quotes.vue?vue&type=style&index=1&id=fa5ef554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5ef554",
  null
  
)

export default component.exports